// Deterministic public practice: no grading requests or persisted learner data.
const normalize = (value) => value.normalize("NFKC").toLowerCase()
  .replace(/[\p{P}\p{S}]/gu, "").replace(/\s+/gu, " ").trim();

const articles = {
  english: /^(a|an|the) /u,
  spanish: /^(el|la|los|las|un|una|unos|unas) /u,
  portuguese: /^(o|a|os|as|um|uma|uns|umas) /u,
  german: /^(der|die|das|ein|eine) /u,
  french: /^(le|la|les|un|une|des) /u,
  italian: /^(il|lo|la|i|gli|le|un|uno|una) /u
};

export const phraseMatches = (answer, expected, language) => {
  const actual = normalize(answer);
  const target = normalize(expected);
  return !!actual && (actual === target ||
    (articles[language] && actual === target.replace(articles[language], "")));
};

const initPhrasePractice = () => {
  document.querySelectorAll("[data-phrase-practice]").forEach((root) => {
    if (root.dataset.practiceInitialized) return;
    root.dataset.practiceInitialized = "true";
    const items = JSON.parse(root.dataset.items);
    const find = (name) => root.querySelector(`[data-practice-${name}]`);
    const form = find("form");
    const input = form.querySelector("input");
    const audio = document.createElement("audio");
    audio.controls = true;
    audio.preload = "none";
    find("audio").append(audio);
    let index = 0;
    let missed = [];
    let results = [];
    let checked = false;

    const showPhrase = () => {
      checked = false;
      input.value = "";
      input.disabled = false;
      form.querySelector("button").disabled = false;
      find("feedback").textContent = "";
      find("next").hidden = true;
      audio.src = items[index].audio;
      input.focus();
    };
    const start = () => {
      index = 0;
      missed = [];
      results = [];
      find("results").hidden = true;
      find("start").hidden = true;
      find("round").hidden = false;
      showPhrase();
    };
    find("start").hidden = false;
    find("start").addEventListener("click", start);
    find("restart").addEventListener("click", start);
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      if (checked || !input.value.trim()) return;
      checked = true;
      audio.pause();
      const item = items[index];
      const correct = phraseMatches(input.value, item.phrase, root.dataset.language);
      if (!correct) missed.push(item);
      results.push(correct ? "✓" : "✗");
      find("feedback").textContent = `${correct ? "✓" : "✗"} ${item.phrase} · ${item.translation}`;
      input.disabled = true;
      form.querySelector("button").disabled = true;
      find("next").hidden = false;
      find("next").focus();
    });
    find("next").addEventListener("click", () => {
      if (!checked) return;
      index += 1;
      if (index < items.length) { showPhrase(); return; }
      find("round").hidden = true;
      find("results").hidden = false;
      // One mark per phrase is a score without numerals in learner copy.
      find("score").textContent = results.join(" ");
      find("missed").replaceChildren();
      missed.forEach((item) => {
        const li = document.createElement("li");
        li.textContent = `${item.phrase} · ${item.translation}`;
        find("missed").append(li);
      });
      const cta = find("cta");
      const url = new URL(cta.href, window.location.origin);
      // A perfect round still hands off: save the whole round instead.
      const saved = missed.length ? missed : items;
      url.searchParams.set("phrases", saved.map((item) => item.id).join(","));
      cta.href = url.pathname + url.search;
      if (!missed.length) cta.textContent = cta.dataset.saveAllLabel;
      find("results").focus();
    });
    document.addEventListener("turbo:before-cache", () => audio.pause(), { once: true });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPhrasePractice);
} else {
  initPhrasePractice();
}
document.addEventListener("turbo:load", initPhrasePractice);
